export default __webpack_public_path__ + "static/media/uploader-tandem-problem-2.f95a2d30.png";